import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Text, { FontStyle } from '~/components/core/Text'
import AgentTalkSpeedStat from '~/pages/CallAnalytics/Transcription/Statistics/AgentTalkSpeedStat'
import AgentTalkTimeStat from '~/pages/CallAnalytics/Transcription/Statistics/AgentTalkTimeStat'
import HoldTimeAndPausesStat from '~/pages/CallAnalytics/Transcription/Statistics/HoldTimeAndPausesStat'
import InterruptionsStat from '~/pages/CallAnalytics/Transcription/Statistics/InterruptionsStat'
import SentimentByQuarterStat from '~/pages/CallAnalytics/Transcription/Statistics/SentimentByQuarterStat'
import { CallTranscript } from '~/types/CallTranscript'

const TranscriptStatisticsPanelWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--chakra-colors-bg-subtle);
  overflow: scroll;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 300px;
  margin: 20px 0px 20px 0px;
`

const SummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  margin: 20px 0px 20px 0px;
`
interface TranscriptStatisticsPanelProps {
  transcript: CallTranscript
}
const TranscriptStatisticsPanel = ({
  transcript,
}: TranscriptStatisticsPanelProps) => {
  const { t } = useTranslation()
  const hasSummary = transcript.ConversationCharacteristics.ContactSummary
  return (
    <TranscriptStatisticsPanelWrapper>
      {hasSummary && (
        <SummaryWrapper>
          <Text
            fontStyle={FontStyle.Large}
            color="var(--chakra-colors-fg-default)"
            align="left"
          >
            {t('callDetails.callSummary')}
          </Text>
          <Text
            fontStyle={FontStyle.bSmall}
            color="var(--chakra-colors-fg-subtle)"
          >
            {
              transcript.ConversationCharacteristics.ContactSummary!
                .AutoGenerated.OverallSummary.Content
            }
          </Text>
        </SummaryWrapper>
      )}
      <TitleWrapper>
        <Text
          fontStyle={FontStyle.Large}
          color="var(--chakra-colors-fg-default)"
        >
          {t('callDetails.callStatistics')}
        </Text>
      </TitleWrapper>
      <HoldTimeAndPausesStat
        transcript={transcript}
        width={300}
        margin="0px 0px 20px 0px"
      />
      <AgentTalkTimeStat
        transcript={transcript}
        width={300}
        margin="0px 0px 20px 0px"
      />
      <AgentTalkSpeedStat
        transcript={transcript}
        width={300}
        margin="0px 0px 20px 0px"
      />
      <InterruptionsStat
        transcript={transcript}
        width={300}
        margin="0px 0px 20px 0px"
      />
      <SentimentByQuarterStat
        transcript={transcript}
        width={300}
        margin="0px 0px 20px 0px"
      />
    </TranscriptStatisticsPanelWrapper>
  )
}

export default TranscriptStatisticsPanel
